<template>
  <div>
    <melon-t-v-banner :is-search="isSearch" />
    <div class="contents">
      <melon-t-v-guide v-if="!isSearch" />
      <section class="section--pt-md">
        <div class="inner _pb-md">
          <melon-t-v-schedule @setIsSearch="setIsSearch" @setSearchObj="setSearchObj" />
          <melon-t-v-search-schedule v-if="isSearch" :search-obj="searchObj" @onDeselect="handleDeselect" />
          <melon-t-v-schedule-list v-if="!isSearch" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import MelonTVBanner from '@/views/pages/melonTV/components/MelonTVBanner'
import MelonTVGuide from '@/views/pages/melonTV/components/MelonTVGuide'
import MelonTVSchedule from '@/views/pages/melonTV/components/MelonTVSchedule'
import MelonTVSearchSchedule from '@/views/pages/melonTV/components/MelonTVSearchSchedule'
import MelonTVScheduleList from '@/views/pages/melonTV/components/MelonTVSchedule/MelonTVScheduleList'
export default {
  name: 'MelonTV',
  components: { MelonTVSchedule, MelonTVSearchSchedule, MelonTVGuide, MelonTVBanner, MelonTVScheduleList },
  data() {
    return {
      isSearch: false,
      searchObj: {}
    }
  },
  methods: {
    setIsSearch(value) {
      this.isSearch = value
    },
    setSearchObj(searchObj) {
      this.searchObj = searchObj
    },
    handleDeselect() {
      this.isSearch = false
      this.searchObj = {}
    }
  }
}
</script>
